import React from 'react'

import CSSModules from 'react-css-modules'
import styles from './style.module.scss'

import { useNavigate } from 'react-router-dom'
import checkIcon from '../../../../../assets/images/spa/check_icon.svg'
import alertIcon from '../../../../../assets/images/spa/alert_icon.svg'
import { MonthlyWorkReport } from 'javascripts/api/generated'

export interface MonthlyWorkReportTableProps {
  monthlyWorkReports: Array<MonthlyWorkReport>;
}

interface StatusInterface {
  'active': string,
  'waiting_acceptance': string,
  'accepted': string,
  'suspending_acceptance': string,
  'waiting_cancellation_agreement': string,
}

type Status = keyof StatusInterface;

const ClientMonthlyWorkReportsTable: React.FC<MonthlyWorkReportTableProps> = CSSModules<React.FC<MonthlyWorkReportTableProps>>((props) => {
  const navigate = useNavigate()

  const handleClick = (monthlyWorkReportId: number) => {
    return () => { navigate(`/clients/monthly_work_reports/${monthlyWorkReportId}`) }
  }

  const  displayStatus: (status: Status) => string = (status) => {
    const displayStatuses: StatusInterface  = {
      'active': '稼働中',
      'waiting_acceptance': '提出済み',
      'accepted': '提出済み',
      'suspending_acceptance': '提出済み',
      'waiting_cancellation_agreement': '提出済み'
    }
    return displayStatuses[status]
  }

  const iconStatus: (status: Status) => string = (icon) => {
    const iconStatuses = {
      'active': alertIcon,
      'waiting_acceptance': checkIcon,
      'accepted': checkIcon,
      'suspending_acceptance': checkIcon,
      'waiting_cancellation_agreement': checkIcon
    }
    return iconStatuses[icon]
  }
  const formatDate: (dateStr: string) => string = (dateStr) => {
    if (!dateStr) return null

    const yyyy = dateStr.substring(0, 4)
    const mm = parseInt(dateStr.substring(4, 6), 10)

    return `${yyyy}年${mm}月`
  }

  return (
    <>
    <table className='client-bills-table' styleName='container'>
      <thead>
      <tr styleName='box-title'>
        <th styleName='item-title'>稼働年月</th>
        <th styleName='item-title'>稼働者</th>
        <th styleName='item-title'>案件名</th>
        <th styleName='item-title'>ステータス</th>
      </tr>
      </thead>
      <tbody styleName='content-container'>
      {props.monthlyWorkReports.map((monthlyWorkReport) => {
        return(
          <tr styleName='box-content' key={monthlyWorkReport.id} onClick={handleClick(monthlyWorkReport.id)}>
              <td>{formatDate(monthlyWorkReport.projectMonthlyTerm.targetMonth)}</td>
              <td>{monthlyWorkReport.projectMonthlyTerm.project.user.fullName}</td>
              <td>{monthlyWorkReport.projectMonthlyTerm.project.title}</td>
              <td styleName={monthlyWorkReport.status === 'active' ? 'active' : 'submit'}><div styleName='status-item'><img src={iconStatus(monthlyWorkReport.status as Status)} alt="Icon" styleName='bills-icon'/>{displayStatus(monthlyWorkReport.status as Status)}</div></td>
          </tr>
        )
      })}
      </tbody>
      </table>
    </>
  )
  }, styles)

export default ClientMonthlyWorkReportsTable
